import { useQuery } from "@apollo/client";

import { GqlProjectGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ProjectListScreen_GetAllDocument } from "../queries.generated";

export default function useProjectListScreen_GetAll(params: GqlProjectGetAllParams) {
    const { data, loading, error } = useQuery(ProjectListScreen_GetAllDocument, {
        variables: {
            params: params,
        },
    });

    const queryInfo = data?.projectGetAll?.queryInfo;
    const [_, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        totalRows: total,
        sortableColumns: queryInfo?.sortableColumns,
        data: data?.projectGetAll?.data,
    };
}
